/**
 * Path Configuration
 * @apal/web-apal
 *
 * Route paths for the standalone APAL portal application.
 * Note: No /apal prefix - routes are at root level.
 */

export const paths = {
  home: "/",
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  dashboard: {
    index: "/dashboard",
    goals: {
      index: "/dashboard/goals",
      create: "/dashboard/goals/create",
      createManual: "/dashboard/goals/create/manual",
      createAi: (personaId: string) => `/dashboard/goals/create/ai/${personaId}`,
      details: (goalId: string) => `/dashboard/goals/${goalId}`,
      edit: (goalId: string) => `/dashboard/goals/${goalId}/edit`,
      assessment: (goalId: string) => `/dashboard/goals/${goalId}/assessment`,
      assessmentComplete: (goalId: string) => `/dashboard/goals/${goalId}/assessment/complete`,
      assessments: (goalId: string) => `/dashboard/goals/${goalId}/assessments`,
      assignments: "/dashboard/goals/assignments",
      team: "/dashboard/goals/team",
      sharedWithMe: "/dashboard/goals/shared-with-me",
      share: (goalId: string) => `/dashboard/goals/${goalId}/share`,
      scores: (goalId: string) => `/dashboard/goals/${goalId}/scores`,
      scheduling: (goalId: string) => `/dashboard/goals/${goalId}/scheduling`,
    },
    assessments: "/dashboard/assessments",
    team: "/dashboard/team",
    company: "/dashboard/company",
    analytics: "/dashboard/analytics",
    behavioral: "/dashboard/behavioral",
    employees: {
      index: "/dashboard/employees",
      import: "/dashboard/employees/import",
      importHistory: "/dashboard/employees/import/history",
    },
    help: {
      index: "/dashboard/help",
      article: (slug: string) => `/dashboard/help/${slug}`,
      contact: "/dashboard/help/contact",
    },
    account: {
      index: "/dashboard/account",
      profile: "/dashboard/account/profile",
      security: "/dashboard/account/security",
      notifications: "/dashboard/account/notifications",
      sessions: "/dashboard/account/sessions",
    },
  },
  errors: {
    notAuthorized: "/errors/not-authorized",
    notFound: "/errors/not-found",
    internalServerError: "/errors/internal-server-error",
  },
} as const;
